/**
 * Search Filters - Metafield-based filtering for movie posters
 * All filtering uses product metafields, not tags
 * Requires jQuery
 */

(function ($) {
  'use strict'

  // ============================================================
  // Filter State Manager
  // ============================================================
  var FilterState = {
    genre: [],
    actors: [],
    decade: [],
    franchise: [],
    size: [],
    price: []
  }

  // Expose for debugging
  window.DebugFilterState = FilterState

  // ============================================================
  // Product Data Helpers - Extract from metafields
  // ============================================================
  var ProductHelpers = {
    // Get metafield value safely — supports both nested (Liquid) and flat (JSON) formats
    getMetafield: function (product, namespace, key) {
      if (!product.metafields) return null
      // Flat format from products.json: metafields.Genre, metafields.Actor, etc.
      if (product._flatMetafields) {
        return product.metafields[key] || null
      }
      // Nested format from Liquid: metafields.Products.Genre
      var ns = product.metafields[namespace]
      if (!ns) return null
      var value = ns[key]
      return value || null
    },

    // Parse comma-separated list from metafield
    parseMetafieldList: function (value) {
      if (!value) return []
      var str = String(value)
      return str.split(',').map(function (s) {
        return s.trim().replace(/["'[\]]/g, '')
      }).filter(function (s) {
        return s.length > 0
      })
    },

    // Get product genres from metafields.Products.Genre
    getGenres: function (product) {
      var value = this.getMetafield(product, 'Products', 'Genre')
      return this.parseMetafieldList(value)
    },

    // Get product actors from metafields.Products.Actor
    getActors: function (product) {
      var value = this.getMetafield(product, 'Products', 'Actor')
      return this.parseMetafieldList(value)
    },

    // Get product sizes from metafields.products.size
    getSize: function (product) {
      var value = this.getMetafield(product, 'products', 'size')
      if (value) {
        var sizes = this.parseMetafieldList(value)
        return sizes.length > 0 ? sizes[0] : ''
      }
      return ''
    },

    // Get product year from metafields.Products.Year
    getYear: function (product) {
      var value = this.getMetafield(product, 'Products', 'Year')
      if (value) {
        var years = this.parseMetafieldList(value)
        if (years.length > 0) {
          var match = years[0].match(/\d{4}/)
          if (match) return match[0]
        }
      }
      return ''
    },

    // Get decade from year
    getDecade: function (product) {
      var year = this.getYear(product)
      if (!year) return ''
      var y = parseInt(year, 10)
      if (!y || y < 1900 || y > 2099) return ''
      return Math.floor(y / 10) * 10 + 's'
    },

    // Get product franchises from metafields.Products.Franchise
    getFranchises: function (product) {
      var value = this.getMetafield(product, 'Products', 'Franchise')
      return this.parseMetafieldList(value)
    }
  }

  // ============================================================
  // Product Card Renderer
  // ============================================================
  var ProductRenderer = {
    escapeHtml: function (str) {
      return $('<div>').text(str).html()
    },

    getImageUrl: function (product) {
      if (product.featured_image) {
        return typeof product.featured_image === 'string'
          ? product.featured_image
          : (product.featured_image.src || '')
      }
      if (product.images && product.images.length > 0) {
        return typeof product.images[0] === 'string'
          ? product.images[0]
          : (product.images[0].src || '')
      }
      return ''
    },

    formatPrice: function (product) {
      var cents = product.price || product.price_min || 0
      if (!cents) return ''
      return '$' + (cents / 100).toFixed(2)
    },

    getProductUrl: function (product) {
      return product.url || '/products/' + (product.handle || '')
    },

    renderCard: function (product) {
      var imageUrl = this.getImageUrl(product)
      var title = this.escapeHtml(product.title || '')
      var size = this.escapeHtml(ProductHelpers.getSize(product))
      var price = this.formatPrice(product)
      var productUrl = this.escapeHtml(this.getProductUrl(product))
      var productId = product.id || product.handle
      var decade = ProductHelpers.getDecade(product)

      var imgHtml = imageUrl
        ? '<div class="img-zoom-container"><img src="' + imageUrl + '" class="img-fluid white-inlay w-100" alt="' + title + '" loading="lazy"></div>'
        : '<div class="placeholder-img"><span>No Image</span></div>'

      var sizePriceHtml = ''
      if (size) sizePriceHtml += '<span>' + size + '</span>'
      if (price) sizePriceHtml += '<span class="featured-products__price">' + price + '</span>'

      return '<div class="col product-card" data-product-id="' + productId + '" data-decade="' + this.escapeHtml(decade) + '">' +
        '<a href="' + productUrl + '" class="link-reset text-decoration-none text-reset d-inline-block" tabindex="-1" title="' + title + '">' +
          '<div class="featured-products__product position-relative overflow-hidden flex-shrink-0 p-4">' +
            imgHtml +
          '</div>' +
          '<div class="featured-products__info py-2 text-start">' +
            '<div class="featured-products__info-line1 global-context fw-bold lh-sm mb-1" style="font-size: 14px; color: #3c3c3c;">' +
              '<strong>' + title + '</strong>' +
            '</div>' +
            '<div class="featured-products__info-line2 global-context">' +
              sizePriceHtml +
            '</div>' +
            '<div class="details-link">Details <span class="details-link-chevron"></span></div>' +
          '</div>' +
        '</a>' +
      '</div>'
    },

    renderNoResults: function () {
      return '<div class="col-18 py-5 text-center text-muted">' +
        '<p class="mb-0">No results found.</p>' +
      '</div>'
    },

    renderAll: function (products) {
      var $grid = $('#search-results-grid')

      // Check if products are already rendered server-side
      var $existingCards = $grid.find('.product-card')

      if ($existingCards.length > 0) {
        // Products are server-side rendered, just initialize filters
        return
      }

      // Client-side rendering (fallback)
      $grid.empty()

      if (products && products.length > 0) {
        var html = ''
        $.each(products, function (i, product) {
          html += ProductRenderer.renderCard(product)
        })
        $grid.html(html)
      } else {
        $grid.html(this.renderNoResults())
      }
    }
  }

  // ============================================================
  // Filter Engine (exposed for debugging)
  // ============================================================
  var FilterEngine = {
    _debugLogged: false,
    // Check if product matches current filters
    matches: function (product) {
      var genres = ProductHelpers.getGenres(product)
      var actors = ProductHelpers.getActors(product)
      var franchises = ProductHelpers.getFranchises(product)
      var size = ProductHelpers.getSize(product)
      var decade = ProductHelpers.getDecade(product)

      if (!FilterEngine._debugLogged && product._flatMetafields) {
        FilterEngine._debugLogged = true
        console.log('[FilterDebug] sample product metafields:', product.metafields)
        console.log('[FilterDebug] genres:', genres, 'actors:', actors, 'size:', size, 'decade:', decade, 'franchises:', franchises)
        console.log('[FilterDebug] FilterState:', JSON.stringify(FilterState))
      }

      // Exclude gift cards
      if (product.title && product.title.indexOf('Gift Card') !== -1) {
        return false
      }

      // Genre filter - match ANY selected genre
      if (FilterState.genre.length > 0) {
        var hasGenre = false
        $.each(FilterState.genre, function (_, filterGenre) {
          if ($.inArray(filterGenre, genres) !== -1) {
            hasGenre = true
            return false
          }
        })
        if (!hasGenre) return false
      }

      // Actor filter - match ANY selected actor
      if (FilterState.actors.length > 0) {
        var hasActor = false
        $.each(FilterState.actors, function (_, filterActor) {
          if ($.inArray(filterActor, actors) !== -1) {
            hasActor = true
            return false
          }
        })
        if (!hasActor) return false
      }

      // Size filter - match ANY selected size
      if (FilterState.size.length > 0) {
        var hasSize = false
        $.each(FilterState.size, function (_, filterSize) {
          if (size && size.toLowerCase() === filterSize.toLowerCase()) {
            hasSize = true
            return false
          }
        })
        if (!hasSize) return false
      }

      // Decade filter - match ANY selected decade
      if (FilterState.decade.length > 0) {
        if (!decade) return false
        var hasDecade = false
        $.each(FilterState.decade, function (_, filterDecade) {
          if (decade === filterDecade) {
            hasDecade = true
            return false
          }
        })
        if (!hasDecade) return false
      }

      // Franchise filter - match ANY selected franchise
      if (FilterState.franchise.length > 0) {
        var hasFranchise = false
        $.each(FilterState.franchise, function (_, filterFranchise) {
          if ($.inArray(filterFranchise, franchises) !== -1) {
            hasFranchise = true
            return false
          }
        })
        if (!hasFranchise) return false
      }

      // Price filter - match ANY selected band, lower-inclusive [lo, hi)
      if (FilterState.price.length > 0) {
        var cents = product.price || product.price_min || 0
        var dollars = cents / 100
        var inBand = false
        $.each(FilterState.price, function (_, token) {
          var parts = token.split('-')
          var lo = parseFloat(parts[0])
          var hi = parseFloat(parts[1])
          if (dollars >= lo && dollars < hi) {
            inBand = true
            return false
          }
        })
        if (!inBand) return false
      }

      return true
    },

    // Return products matching current filters
    getFiltered: function (products) {
      if (!products) return []
      return products.filter(function (p) {
        return FilterEngine.matches(p)
      })
    },

    // Apply filters and update grid
    apply: function (products) {
      var filtered = FilterEngine.getFiltered(products)

      if (window.isBrowseAll) {
        ClientPagination.reset()
        ClientPagination.render(filtered)
        FilterEngine.updateResultCount(filtered.length, products ? products.length : 0)
        return
      }

      // Server-rendered path: show/hide existing DOM cards
      var $grid = $('#search-results-grid')
      var visibleCount = 0
      var totalCount = products ? products.length : 0

      $grid.children('.product-card').each(function () {
        var $card = $(this)
        var productId = $card.data('product-id')
        var product = $.grep(products, function (p) {
          return (p.id || p.handle) === productId
        })[0]

        if (!product) {
          $card.hide()
          return
        }

        if (FilterEngine.matches(product)) {
          $card.show()
          $card.css('opacity', '1')
          visibleCount++
        } else {
          $card.hide()
        }
      })

      FilterEngine.updateResultCount(visibleCount, totalCount)

      var $noResults = $('#browse-all-no-results')
      if ($noResults.length) {
        $noResults.toggle(visibleCount === 0)
      }
    },

    updateResultCount: function (visibleCount, totalCount) {
      window.searchResultsCount = visibleCount
      var hasActive = FilterEngine.hasActiveFilters()
      $('#clear-filters-btn').toggle(hasActive)
    },

    // Check if any filters are active
    hasActiveFilters: function () {
      return FilterState.genre.length > 0 ||
             FilterState.actors.length > 0 ||
             FilterState.franchise.length > 0 ||
             FilterState.size.length > 0 ||
             FilterState.decade.length > 0 ||
             FilterState.price.length > 0
    },

    // Clear all filters
    clearAll: function () {
      FilterState.genre = []
      FilterState.actors = []
      FilterState.franchise = []
      FilterState.size = []
      FilterState.decade = []
      FilterState.price = []

      // Uncheck all filter checkboxes (price boxes share the data-filter-type attr)
      $('[data-filter-type]:checked').prop('checked', false)

      // Reset filter pagination
      FilterPagination.resetAll()

      // Re-apply filters (shows all)
      FilterEngine.apply(window.searchResults || [])
    }
  }

  // ============================================================
  // Price Range — $500-interval band checkboxes
  // ============================================================
  var PriceRange = {
    BAND_SIZE: 500,

    // Calculate min and max prices from products
    getPriceRange: function () {
      var products = window.searchResults || []
      if (products.length === 0) {
        return { min: 10, max: 1000 }
      }
      var minPrice = Infinity
      var maxPrice = 0
      products.forEach(function (product) {
        var price = product.price || product.price_min || 0
        var dollars = price / 100
        if (dollars < minPrice) minPrice = dollars
        if (dollars > maxPrice) maxPrice = dollars
      })
      return {
        min: Math.floor(minPrice),
        max: Math.ceil(maxPrice)
      }
    },

    // Build $500 band checkboxes from $0 to ceil(max price)
    renderBands: function () {
      var $container = $('.price-filters')
      if (!$container.length) return

      var $empty = $('#price-filters-empty')
      var $link = $container.find('.filter-pagination-link').closest('.text-center')

      // Remove any previously rendered bands (idempotent re-render)
      $container.find('.filter-checkbox').remove()

      var max = Math.ceil(this.getPriceRange().max)
      if (!max || max <= 0) {
        $empty.show()
        return
      }

      var selected = FilterState.price
      var html = ''
      for (var lo = 0; lo < max; lo += this.BAND_SIZE) {
        var hi = Math.min(lo + this.BAND_SIZE, max)
        var token = lo + '-' + hi
        var label = '$' + lo + ' - $' + hi
        var isChecked = $.inArray(token, selected) !== -1 ? ' checked' : ''
        html += '<div class="filter-checkbox">' +
          '<input type="checkbox" class="form-check-input" id="price-' + token + '"' +
          ' name="price" value="' + token + '"' +
          ' data-filter-type="price" data-filter-value="' + token + '"' + isChecked + '>' +
          '&nbsp;<label class="form-check-label" for="price-' + token + '">' + label + '</label>' +
          '</div>'
      }

      // Insert bands before the show-more link wrapper
      if ($link.length) {
        $(html).insertBefore($link)
      } else {
        $container.append(html)
      }
      $empty.hide()
    }
  }

  // ============================================================
  // Filter Pagination - Show 10 items at a time
  // ============================================================
  var FilterPagination = {
    itemsPerPage: 10,
    state: {
      genre: { page: 1, expanded: false },
      actors: { page: 1, expanded: false },
      decade: { page: 1, expanded: false },
      franchise: { page: 1, expanded: false },
      size: { page: 1, expanded: false },
      price: { page: 1, expanded: false }
    },

    // Get total items in a filter
    getTotalItems: function (filterType) {
      return $('.' + filterType + '-filters').find('.filter-checkbox').length
    },

    // Update visibility based on current page
    updateVisibility: function (filterType) {
      var $container = $('.' + filterType + '-filters')
      var $items = $container.find('.filter-checkbox')
      var totalItems = $items.length
      var state = this.state[filterType]
      var maxVisible = state.page * this.itemsPerPage

      $items.each(function (index) {
        if (state.expanded || index < maxVisible) {
          $(this).show()
        } else {
          $(this).hide()
        }
      })

      // Update show more/less link
      this.updateLink(filterType, totalItems)
    },

    // Update the show more/less link visibility and text
    updateLink: function (filterType, totalItems) {
      var $container = $('.' + filterType + '-filters')
      var state = this.state[filterType]
      var $link = $container.find('.filter-pagination-link')

      if (!$link.length) return

      var maxVisible = state.page * this.itemsPerPage

      if (state.expanded) {
        // Show less link
        $link.text('Show less').show()
      } else if (totalItems > maxVisible) {
        // Show more link
        $link.text('Show more').show()
      } else if (totalItems > this.itemsPerPage && !state.expanded) {
        // On first page with more items
        $link.text('Show more').show()
      } else {
        // No more items, hide link
        $link.hide()
      }
    },

    // Show more items
    showMore: function (filterType) {
      this.state[filterType].page++
      this.state[filterType].expanded = true
      this.updateVisibility(filterType)
    },

    // Show less items (collapse)
    showLess: function (filterType) {
      this.state[filterType].page = 1
      this.state[filterType].expanded = false
      this.updateVisibility(filterType)
    },

    // Reset all filters to initial state
    resetAll: function () {
      for (var filterType in this.state) {
        if (Object.prototype.hasOwnProperty.call(this.state, filterType)) {
          this.state[filterType].page = 1
          this.state[filterType].expanded = false
          this.updateVisibility(filterType)
        }
      }
    },

    // Initialize pagination for all filters
    init: function () {
      var self = this

      // Add click handlers for pagination links
      $(document).on('click', '.filter-pagination-link', function (e) {
        e.preventDefault()
        var $el = $(this)
        var $container = $el.closest('.genre-filters, .actors-filters, .decade-filters, .franchise-filters, .size-filters, .price-filters')
        var filterType = ''

        if ($container.hasClass('genre-filters')) filterType = 'genre'
        else if ($container.hasClass('actors-filters')) filterType = 'actors'
        else if ($container.hasClass('decade-filters')) filterType = 'decade'
        else if ($container.hasClass('franchise-filters')) filterType = 'franchise'
        else if ($container.hasClass('size-filters')) filterType = 'size'
        else if ($container.hasClass('price-filters')) filterType = 'price'

        if ($el.text() === 'Show more') {
          self.showMore(filterType)
        } else {
          self.showLess(filterType)
        }
      })

      // Initialize visibility for all filters
      for (var filterType in this.state) {
        if (Object.prototype.hasOwnProperty.call(this.state, filterType)) {
          this.updateVisibility(filterType)
        }
      }
    }
  }

  // ============================================================
  // Filter URL Sync — persist filter state in URL params across pagination
  // Only active on collection/search pages (not browse-all)
  // ============================================================
  var FilterURL = {
    ARRAY_PARAMS: ['f_genre', 'f_actors', 'f_decade', 'f_franchise', 'f_size', 'f_price'],
    STATE_MAP: {
      f_genre: 'genre',
      f_actors: 'actors',
      f_decade: 'decade',
      f_franchise: 'franchise',
      f_size: 'size',
      f_price: 'price'
    },

    // Write current FilterState into URL without reloading.
    // If on page 2+, navigate to page 1 so user sees results from the start.
    push: function () {
      if (window.isBrowseAll) return
      var wasOnPage = new URLSearchParams(window.location.search).get('page')
      var params = new URLSearchParams(window.location.search)

      // Remove all existing filter params
      var self = this
      self.ARRAY_PARAMS.forEach(function (p) { params.delete(p) })
      // Reset to page 1 whenever filters change
      params.delete('page')

      // Write active filters
      FilterState.genre.forEach(function (v) { params.append('f_genre', v) })
      FilterState.actors.forEach(function (v) { params.append('f_actors', v) })
      FilterState.decade.forEach(function (v) { params.append('f_decade', v) })
      FilterState.franchise.forEach(function (v) { params.append('f_franchise', v) })
      FilterState.size.forEach(function (v) { params.append('f_size', v) })
      FilterState.price.forEach(function (v) { params.append('f_price', v) })

      var qs = params.toString()
      var newUrl = window.location.pathname + (qs ? '?' + qs : '')
      if (wasOnPage && parseInt(wasOnPage, 10) > 1) {
        // Was on page 2+ — hard navigate to page 1 with new filters applied
        window.location.href = newUrl
      } else {
        history.replaceState(null, '', newUrl)
      }
    },

    // Restore FilterState from URL params and check matching boxes
    restore: function () {
      if (window.isBrowseAll) return
      var params = new URLSearchParams(window.location.search)
      var self = this

      Object.keys(self.STATE_MAP).forEach(function (param) {
        var stateKey = self.STATE_MAP[param]
        var values = params.getAll(param)
        if (values.length > 0) {
          FilterState[stateKey] = values
          values.forEach(function (val) {
            $('[data-filter-type="' + stateKey + '"][data-filter-value="' + val + '"]').prop('checked', true)
          })
        }
      })
    }
  }

  // ============================================================
  // Filter Checkbox Events
  // ============================================================
  var FilterEvents = {
    debounceTimer: null,

    init: function () {
      $(document).on('change', '[data-filter-type]', function () {
        var $el = $(this)
        var filterType = $el.data('filter-type')
        var value = $el.data('filter-value')

        if ($el.prop('checked')) {
          if ($.inArray(value, FilterState[filterType]) === -1) {
            FilterState[filterType].push(value)
          }
        } else {
          var index = $.inArray(value, FilterState[filterType])
          if (index !== -1) {
            FilterState[filterType].splice(index, 1)
          }
        }

        FilterURL.push()
        FilterEvents.debouncedApply()
      })

      $('#clear-filters-btn').on('click', function () {
        FilterEngine.clearAll()
        FilterURL.push()
      })
    },

    debouncedApply: function () {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(function () {
        FilterEngine.apply(window.searchResults || [])
      }, 150)
    }
  }

  // ============================================================
  // Initialization
  // ============================================================
  // Client-side Pagination (browse-all only)
  // ============================================================
  var ClientPagination = {
    currentPage: 1,
    itemsPerPage: 100,

    reset: function () {
      this.currentPage = 1
    },

    totalPages: function (totalItems) {
      return Math.ceil(totalItems / this.itemsPerPage)
    },

    pageSlice: function (products) {
      var start = (this.currentPage - 1) * this.itemsPerPage
      return products.slice(start, start + this.itemsPerPage)
    },

    render: function (filteredProducts) {
      var total = filteredProducts.length
      var pages = this.totalPages(total)
      var current = this.currentPage
      var $container = $('#browse-all-pagination')
      var $grid = $('#search-results-grid')
      var $noResults = $('#browse-all-no-results')

      // Render current page cards
      $grid.empty()
      var slice = this.pageSlice(filteredProducts)
      if (slice.length > 0) {
        var html = ''
        $.each(slice, function (i, product) {
          html += ProductRenderer.renderCard(product)
        })
        $grid.html(html).show()
        $noResults.hide()
      } else {
        $grid.hide()
        $noResults.show()
      }

      // Render pagination controls
      if (pages <= 1) {
        $container.hide().html('')
        return
      }

      var start = (current - 1) * this.itemsPerPage + 1
      var end = Math.min(current * this.itemsPerPage, total)
      var maxVisible = 5
      var startPage = Math.max(1, current - 2)
      var endPage = Math.min(pages, startPage + maxVisible - 1)
      if (endPage - startPage + 1 < maxVisible) {
        startPage = Math.max(1, endPage - maxVisible + 1)
      }

      var html = '<div class="pagination-wrapper">'
      html += '<div class="pagination-info">Showing ' + start + '-' + end + ' of ' + total + ' products</div>'
      html += '<nav aria-label="Pagination"><ul class="pagination-list">'

      if (current > 1) {
        html += '<li class="pagination-item"><a class="pagination-link pagination-link--first" href="#" data-page="1">First</a></li>'
        html += '<li class="pagination-item"><a class="pagination-link pagination-link--prev" href="#" data-page="' + (current - 1) + '">&lt;</a></li>'
      }

      for (var i = startPage; i <= endPage; i++) {
        if (i === current) {
          html += '<li class="pagination-item"><span class="pagination-link active" aria-current="page">' + i + '</span></li>'
        } else {
          html += '<li class="pagination-item"><a class="pagination-link" href="#" data-page="' + i + '">' + i + '</a></li>'
        }
      }

      if (current < pages) {
        html += '<li class="pagination-item"><a class="pagination-link pagination-link--next" href="#" data-page="' + (current + 1) + '">&gt;</a></li>'
        html += '<li class="pagination-item"><a class="pagination-link pagination-link--last" href="#" data-page="' + pages + '">Last</a></li>'
      }

      html += '</ul></nav></div>'
      $container.html(html).show()
    },

    init: function () {
      var self = this
      $(document).on('click', '#browse-all-pagination [data-page]', function (e) {
        e.preventDefault()
        var page = parseInt($(this).data('page'), 10)
        if (!page) return
        self.currentPage = page
        var filtered = FilterEngine.getFiltered(window.searchResults || [])
        self.render(filtered)
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    }
  }

  // ============================================================
  // Browse-All JSON loader
  // ============================================================
  var BrowseAllLoader = {
    normalizeProduct: function (p) {
      // Map flat products.json shape to what ProductHelpers expects
      return {
        id: p.id,
        title: p.title,
        handle: p.handle,
        url: '/products/' + p.handle,
        price: p.price ? Math.round(parseFloat(p.price) * 100) : 0,
        featured_image: p.image ? { src: p.image } : null,
        images: p.image ? [{ src: p.image }] : [],
        metafields: p.metafields || {},
        _flatMetafields: true
      }
    },

    load: function (onComplete) {
      var url = window.browseAllProductsUrl
      if (!url) {
        onComplete([])
        return
      }

      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status)
          return res.json()
        })
        .then(function (data) {
          var products = Array.isArray(data) ? data : []
          onComplete(products.map(BrowseAllLoader.normalizeProduct))
        })
        .catch(function (err) {
          console.error('Browse-all load failed:', err)
          onComplete([])
        })
    }
  }

  function excludeGiftCards (products) {
    return products.filter(function (p) {
      return !(p.title && p.title.indexOf('Gift Card') !== -1)
    })
  }

  // ============================================================
  function initWithProducts (products) {
    products = excludeGiftCards(products)
    window.searchResults = products
    window.searchResultsCount = products.length
    window.allProductsCount = products.length

    $('#browse-all-loading').hide()

    ClientPagination.init()
    ClientPagination.render(products)

    PriceRange.renderBands()
    FilterEvents.init()
    FilterPagination.init()
  }

  // Rewrite all server pagination hrefs using window.location (full URL, all params preserved)
  function initPaginationLinkSync () {
    if (window.isBrowseAll) return

    var currentParams = new URLSearchParams(window.location.search)
    currentParams.delete('page')

    // Rewrite hrefs on load so numbered/First/Last have correct base params
    $('.pagination-link[href]').each(function () {
      var $a = $(this)
      var href = $a.attr('href')
      if (!href || href === '#') return
      var destParams = new URLSearchParams(href.split('?')[1] || '')
      var pageVal = destParams.get('page')
      // Rebuild: current params (minus page) + destination page
      var merged = new URLSearchParams(currentParams.toString())
      if (pageVal) merged.set('page', pageVal)
      $a.attr('href', window.location.pathname + '?' + merged.toString())
    })

    // Also intercept clicks to carry any f_* params added after page load
    $(document).on('click', '.pagination-link[href]', function (e) {
      var href = $(this).attr('href')
      if (!href || href === '#') return
      e.preventDefault()
      var destParams = new URLSearchParams(href.split('?')[1] || '')
      var liveParams = new URLSearchParams(window.location.search)
      liveParams.delete('page')
      var pageVal = destParams.get('page')
      var merged = new URLSearchParams(liveParams.toString())
      if (pageVal) merged.set('page', pageVal)
      window.location.href = window.location.pathname + '?' + merged.toString()
    })
  }

  function init () {
    if (window.isBrowseAll) {
      BrowseAllLoader.load(function (products) {
        initWithProducts(products)
      })
      return
    }

    var products = window.searchResults || []
    if (products.length === 0) {
      return
    }

    products = excludeGiftCards(products)
    window.searchResults = products

    ProductRenderer.renderAll(products)
    PriceRange.renderBands()
    FilterEvents.init()
    FilterPagination.init()
    FilterURL.restore()
    initPaginationLinkSync()
    FilterEngine.apply(products)
  }

  // Run on document ready
  $(document).ready(init)
})(jQuery)
